import label from "@/lang/StaticLabels.js";

export default {
  commodities: (state) => {
    return state.commodities;
  },
  commodityOptions: (state) => {
    const commodityOptions = [];
    state.commodities.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: [item.code, item.title, item.unitCountTitle]
          .filter((item) => item)
          .join(" | "),
        codeTitle: item.code + " | " + item.title,
        title: item.title,
        code: item.code,
        unitCountId: item.unitCountId,
        unitCountTitle: item.unitCountTitle,
        groupTitle: item.groupTitle || item.commodityGroupTitle,
        groupCode: item.groupCode || item.commodityGroupCode,
        width: item.width,
        height: item.height,
        material: item.material,
      };
      commodityOptions.push(pushItem);
    }
    return commodityOptions;
  },

  companyOptions: (state) => {
    const companyOptions = [];
    state.companies.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      companyOptions.push(pushItem);
    }
    return companyOptions;
  },

  branchOptions: (state) => {
    const branchOptions = [];
    state.branches.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.branchName,
        isCurrent: item.isCurrent,
      };
      branchOptions.push(pushItem);
    }
    return branchOptions;
  },

  myBrancheOptions: (state) => {
    const myBrancheOptions = [];
    state.myBranches.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.branchName,
        isCurrent: item.isCurrent,
      };
      myBrancheOptions.push(pushItem);
    }
    return myBrancheOptions;
  },

  myFiscalYearOptions: (state) => {
    const myFiscalYearOptions = [];
    state.myFiscalYear.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      myFiscalYearOptions.push(pushItem);
    }
    return myFiscalYearOptions;
  },

  roleOptions: (state) => {
    const roleOptions = [];
    state.roles.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      roleOptions.push(pushItem);
    }
    return roleOptions;
  },

  unitOptions: (state) => {
    const unitOptions = [];
    state.units.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
        coefficient: item.coefficient,
      };
      unitOptions.push(pushItem);
    }
    return unitOptions;
  },

  materialOptions: (state) => {
    const materialOptions = [];
    state.materials.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      materialOptions.push(pushItem);
    }
    return materialOptions;
  },

  productOptions: (state) => {
    const productOptions = [];
    state.products.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      productOptions.push(pushItem);
    }
    return productOptions;
  },

  customerOptions: (state) => {
    const customerOptions = [];
    state.customers.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      customerOptions.push(pushItem);
    }
    return customerOptions;
  },

  categoryOptions: (state) => {
    const categoryOptions = [];
    state.categories.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      categoryOptions.push(pushItem);
    }
    return categoryOptions;
  },

  branchYearOptions: (state) => {
    const branchYearOptions = [];
    state.branchYears.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      branchYearOptions.push(pushItem);
    }
    return branchYearOptions;
  },

  userOptions: (state) => {
    const userOptions = [];
    state.users.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      userOptions.push(pushItem);
    }
    return userOptions;
  },

  settlementTypeOptions: (state) => {
    const settlementTypeOptions = [];
    state.settlementTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      settlementTypeOptions.push(pushItem);
    }
    return settlementTypeOptions;
  },

  wareOptions: (state) => {
    const wareOptions = [];
    state.wares.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
        code: item.code,
      };
      wareOptions.push(pushItem);
    }
    return wareOptions;
  },

  wareShelfInfoOptions: (state) => {
    const wareShelfInfoOptions = [];
    state.wareShelfInfos.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
        code: item.code,
      };
      wareShelfInfoOptions.push(pushItem);
    }
    return wareShelfInfoOptions;
  },

  wareShelfInfoOptions2: (state) => {
    const wareShelfInfoOptions2 = [];
    state.wareShelfInfos2.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
        code: item.code,
      };
      wareShelfInfoOptions2.push(pushItem);
    }
    return wareShelfInfoOptions2;
  },

  wareWithoutLimitOptions: (state) => {
    const wareWithoutLimitOptions = [];
    state.waresWithoutLimit.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
        code: item.code,
      };
      wareWithoutLimitOptions.push(pushItem);
    }
    return wareWithoutLimitOptions;
  },

  wareCategoryOptions: (state) => {
    const wareCategoryOptions = [];
    state.wareCategories.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      wareCategoryOptions.push(pushItem);
    }
    return wareCategoryOptions;
  },

  countryOptions: (state) => {
    const countryOptions = [];
    state.countries.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
        isDefault: item.isDefault,
      };
      countryOptions.push(pushItem);
    }
    return countryOptions;
  },

  allProvinceOptions: (state) => {
    const allProvinceOptions = [];
    state.allProvinces.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      allProvinceOptions.push(pushItem);
    }
    return allProvinceOptions;
  },

  provinceOptions: (state) => {
    const provinceOptions = [];
    state.provinces.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      provinceOptions.push(pushItem);
    }
    return provinceOptions;
  },

  provinceForAddressOptions: (state) => {
    const provinceForAddressOptions = [];
    state.provincesForAddress.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      provinceForAddressOptions.push(pushItem);
    }
    return provinceForAddressOptions;
  },

  allCityOptions: (state) => {
    const allCityOptions = [];
    state.allCities.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      allCityOptions.push(pushItem);
    }
    return allCityOptions;
  },

  cityOptions: (state) => {
    const cityOptions = [];
    state.cities.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      cityOptions.push(pushItem);
    }
    return cityOptions;
  },

  cityForAddressOptions: (state) => {
    const cityForAddressOptions = [];
    state.citiesForAddress.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      cityForAddressOptions.push(pushItem);
    }
    return cityForAddressOptions;
  },

  regionOptions: (state) => {
    const regionOptions = [];
    state.regions.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      regionOptions.push(pushItem);
    }
    return regionOptions;
  },

  personOptions: (state) => {
    const personOptions = [];
    state.persons.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
        code: item.code,
        title: item.code + " | " + item.title,
      };
      personOptions.push(pushItem);
    }
    return personOptions;
  },

  personTypeOptions: (state) => {
    const personTypeOptions = [];
    state.personTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      personTypeOptions.push(pushItem);
    }
    return personTypeOptions;
  },

  prefixeOptions: (state) => {
    const prefixeOptions = [];
    state.prefixes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      prefixeOptions.push(pushItem);
    }
    return prefixeOptions;
  },

  personGroupOptions: (state) => {
    const personGroupOptions = [];
    state.personGroups.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      personGroupOptions.push(pushItem);
    }
    return personGroupOptions;
  },

  personBrancheOptions: (state) => {
    const personBrancheOptions = [];
    state.personBranches.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      personBrancheOptions.push(pushItem);
    }
    return personBrancheOptions;
  },

  positionInformation: (state) => {
    return state.positionInformation;
  },
  positionInformationOptions: (state) => {
    const positionInformationOptions = [];
    state.positionInformation.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      positionInformationOptions.push(pushItem);
    }
    return positionInformationOptions;
  },

  maritalStatuseOptions: (state) => {
    const maritalStatuseOptions = [];
    state.maritalStatuses.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      maritalStatuseOptions.push(pushItem);
    }
    return maritalStatuseOptions;
  },

  sbuOptions: (state) => {
    const sbuOptions = [];
    state.sbus.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      sbuOptions.push(pushItem);
    }
    return sbuOptions;
  },

  sbuTypeOptions: (state) => {
    const sbuTypeOptions = [];
    state.sbuTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      sbuTypeOptions.push(pushItem);
    }
    return sbuTypeOptions;
  },

  bomOptions: (state) => {
    const bomOptions = [];
    state.boms.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      bomOptions.push(pushItem);
    }
    return bomOptions;
  },

  orderOptions: (state) => {
    const orderOptions = [];
    state.orders.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.code,
      };
      orderOptions.push(pushItem);
    }
    return orderOptions;
  },

  produceOrderProcessOptions: (state) => {
    const produceOrderProcessOptions = [];
    state.produceOrderProcesses.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      produceOrderProcessOptions.push(pushItem);
    }
    return produceOrderProcessOptions;
  },

  userGroupOptions: (state) => {
    const userGroupOptions = [];
    state.userGroups.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      userGroupOptions.push(pushItem);
    }
    return userGroupOptions;
  },

  branchFiscalYearsOptions: (state) => {
    const branchFiscalYearsOptions = [];
    state.branchFiscalYears.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      branchFiscalYearsOptions.push(pushItem);
    }
    return branchFiscalYearsOptions;
  },

  fiscalYearById: (state) => {
    return state.fiscalYearById;
  },
  fiscalYearByIdOptions: (state) => {
    const fiscalYearByIdOptions = [];
    state.fiscalYearById.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      fiscalYearByIdOptions.push(pushItem);
    }
    return fiscalYearByIdOptions;
  },

  permissions: (state) => {
    return state.permissions;
  },
  permissionsOptions: (state) => {
    const permissionsOptions = [];
    state.permissions.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      permissionsOptions.push(pushItem);
    }
    return permissionsOptions;
  },

  // شناسه زیرسیستم‌هایی که شرکت جاری خریداری کرده است
  ownedSubSystemIds: (state) => {
    return (state.companySubSystems || []).map((i) => i.subSystemId);
  },

  companySubSystemsLoaded: (state) => {
    return state.companySubSystemsLoaded;
  },

  companySubSystemOptions: (state) => {
    const companySubSystemOptions = [];
    state.companySubSystems.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.subSystemId,
        text: item.displayName,
      };
      companySubSystemOptions.push(pushItem);
    }
    return companySubSystemOptions;
  },

  floatAccountTypes: (state) => {
    return state.floatAccountTypes;
  },
  floatAccountTypeOptions: (state) => {
    const floatAccountTypeOptions = [];
    state.floatAccountTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      floatAccountTypeOptions.push(pushItem);
    }
    return floatAccountTypeOptions;
  },

  floatAccounts: (state) => {
    return state.floatAccounts;
  },

  floatAccountOptions: (state) => {
    const floatAccountOptions = [];
    state.floatAccounts.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
        code: item.code,
      };
      floatAccountOptions.push(pushItem);
    }
    return floatAccountOptions;
  },

  floatAccountGroupOptions: (state) => {
    const floatAccountGroupOptions = [];
    state.floatAccountGroups.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      floatAccountGroupOptions.push(pushItem);
    }
    return floatAccountGroupOptions;
  },

  floatAccountGroup1Options: (state) => {
    const floatAccountGroup1Options = [];
    state.floatAccountGroups1.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      floatAccountGroup1Options.push(pushItem);
    }
    return floatAccountGroup1Options;
  },

  floatAccountGroup2Options: (state) => {
    const floatAccountGroup2Options = [];
    state.floatAccountGroups2.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      floatAccountGroup2Options.push(pushItem);
    }
    return floatAccountGroup2Options;
  },

  floatAccountGroup3Options: (state) => {
    const floatAccountGroup3Options = [];
    state.floatAccountGroups3.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      floatAccountGroup3Options.push(pushItem);
    }
    return floatAccountGroup3Options;
  },

  floatAccountGroup4Options: (state) => {
    const floatAccountGroup4Options = [];
    state.floatAccountGroups4.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      floatAccountGroup4Options.push(pushItem);
    }
    return floatAccountGroup4Options;
  },

  floatAccountGroup5Options: (state) => {
    const floatAccountGroup5Options = [];
    state.floatAccountGroups5.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      floatAccountGroup5Options.push(pushItem);
    }
    return floatAccountGroup5Options;
  },

  genderOptions: (state) => {
    const genderOptions = [];
    state.gender.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      genderOptions.push(pushItem);
    }
    return genderOptions;
  },

  commodityGroupOptions: (state) => {
    const commodityGroupOptions = [];
    state.commodityGroups.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title + " ( " + item.code + " )",
        code: item.code,
      };
      commodityGroupOptions.push(pushItem);
    }
    return commodityGroupOptions;
  },

  wareVoucherTypeOptions: (state) => {
    const wareVoucherTypeOptions = [];
    state.wareVoucherTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.name,
      };
      wareVoucherTypeOptions.push(pushItem);
    }
    return wareVoucherTypeOptions;
  },

  invoiceTypeOptions: (state) => {
    const invoiceTypeOptions = [];
    state.invoiceTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      invoiceTypeOptions.push(pushItem);
    }
    return invoiceTypeOptions;
  },

  personGradeOptions: (state) => {
    const personGradeOptions = [];
    state.personGrades.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      personGradeOptions.push(pushItem);
    }
    return personGradeOptions;
  },

  accountInfos: (state) => {
    return state.accountInfos;
  },
  accountInfoOptions: (state) => {
    const accountInfoOptions = [];
    state.accountInfos.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.accountInfoId ? item.accountInfoId : item.id,
        text: item.accountInfoTitle ? item.accountInfoTitle : item.title,
        code: item.accCode,
        fullTitle: item.fullTitle,
        title: item.code + " | " + item.title,
        mainCode: item.code,
      };
      accountInfoOptions.push(pushItem);
    }
    return accountInfoOptions;
  },

  accountInfoSettingOptions: (state) => {
    const accountInfoSettingOptions = [];
    state.accountInfos.forEach(func);
    function func(item) {
      const pushItem = {
        text: item.accCode + " " + "|" + " " + item.title,
        value: item.id,
      };
      accountInfoSettingOptions.push(pushItem);
    }
    return accountInfoSettingOptions;
  },

  dataOperationOptions: (state) => {
    const dataOperationOptions = [];
    state.dataOperations.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      dataOperationOptions.push(pushItem);
    }
    return dataOperationOptions;
  },

  dataUserOptions: (state) => {
    const dataUserOptions = [];
    state.dataUsers.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text:
          item.username +
          (item.title && item.title.trim() ? " | " + item.title : ""),
      };
      dataUserOptions.push(pushItem);
    }
    return dataUserOptions;
  },

  additionalCommodityParamenterTypeOptions: (state) => {
    const additionalCommodityParamenterTypeOptions = [];
    state.additionalCommodityParamenterTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      additionalCommodityParamenterTypeOptions.push(pushItem);
    }
    return additionalCommodityParamenterTypeOptions;
  },

  filedTypeOptions: (state) => {
    const filedTypeOptions = [];
    state.filedTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      filedTypeOptions.push(pushItem);
    }
    return filedTypeOptions;
  },

  receiptWareVoucherTypeOptions: (state) => {
    const receiptWareVoucherTypeOptions = [];
    state.receiptWareVoucherTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      receiptWareVoucherTypeOptions.push(pushItem);
    }
    return receiptWareVoucherTypeOptions;
  },

  tempReceiptWareVoucherTypeOptions: (state) => {
    const tempReceiptWareVoucherTypeOptions = [];
    state.tempReceiptWareVoucherTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      tempReceiptWareVoucherTypeOptions.push(pushItem);
    }
    return tempReceiptWareVoucherTypeOptions;
  },

  floatAccountConfigOptions: (state) => {
    const floatAccountConfigOptions = [];
    state.floatAccountConfigs.forEach(func);
    function func(item, index) {
      const pushItem = {
        value: item.id,
        text: item.title,
        type: item.floatAccountTypeId,
        uniqueKey: "floatAccount" + index,
      };
      floatAccountConfigOptions.push(pushItem);
    }
    return floatAccountConfigOptions;
  },

  destinationFloatAccountOptions: (state) => {
    const destinationFloatAccountOptions = [];
    state.floatAccountConfigs.forEach(func);
    function func(item) {
      const pushItem = {
        value: `${item.id}-destination`,
        text: item.title,
      };
      destinationFloatAccountOptions.push(pushItem);
    }
    return destinationFloatAccountOptions;
  },

  creditFloatAccountOptions: (state) => {
    const destinationFloatAccountOptions = [];
    state.floatAccountConfigs.forEach(func);
    function func(item) {
      const pushItem = {
        value: `${item.id}-credit`,
        text: item.title,
      };
      destinationFloatAccountOptions.push(pushItem);
    }
    return destinationFloatAccountOptions;
  },

  floatAccounts1Options: (state) => {
    const floatAccounts1Options = [];
    state.floatAccounts1.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
        code: item.code,
        title: item.code + " | " + item.title,
      };
      floatAccounts1Options.push(pushItem);
    }
    return floatAccounts1Options;
  },

  floatAccounts2Options: (state) => {
    const floatAccounts2Options = [];
    state.floatAccounts2.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
        code: item.code,
        title: item.code + " | " + item.title,
      };
      floatAccounts2Options.push(pushItem);
    }
    return floatAccounts2Options;
  },

  floatAccounts3Options: (state) => {
    const floatAccounts3Options = [];
    state.floatAccounts3.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
        code: item.code,
        title: item.code + " | " + item.title,
      };
      floatAccounts3Options.push(pushItem);
    }
    return floatAccounts3Options;
  },

  floatAccounts4Options: (state) => {
    const floatAccounts4Options = [];
    state.floatAccounts4.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
        code: item.code,
        title: item.code + " | " + item.title,
      };
      floatAccounts4Options.push(pushItem);
    }
    return floatAccounts4Options;
  },

  floatAccounts5Options: (state) => {
    const floatAccounts5Options = [];
    state.floatAccounts5.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
        code: item.code,
        title: item.code + " | " + item.title,
      };
      floatAccounts5Options.push(pushItem);
    }
    return floatAccounts5Options;
  },

  floatAccountTextOptions: (state) => {
    const floatAccountTextOptions = [];
    state.floatAccountText.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
        code: item.id,
        title: item.id + " | " + item.title,
      };
      floatAccountTextOptions.push(pushItem);
    }
    return floatAccountTextOptions;
  },

  reviewVoucherAmountFilterTypeOptions: (state) => {
    const reviewVoucherAmountFilterTypeOptions = [];
    state.reviewVoucherAmountFilterTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      reviewVoucherAmountFilterTypeOptions.push(pushItem);
    }
    return reviewVoucherAmountFilterTypeOptions;
  },

  additionalCommodityParameterOptions: (state) => {
    const additionalCommodityParameterOptions = [];
    state.additionalCommodityParameters.forEach(func);
    function func(item, index) {
      let defaultValue = item.defaultValue;
      if (defaultValue != null && Array.isArray(item.dropDown)) {
        const match = item.dropDown.find(
          (z) => String(z.value) === String(defaultValue),
        );
        if (match) {
          defaultValue = match.value;
        }
      }
      const pushItem = {
        index: index,
        value: item.id,
        text: item.title,
        fieldTypeId: item.fieldTypeId,
        dropDown: item.dropDown,
        defaultValue: defaultValue,
        uniqueKey: "param" + index,
      };
      additionalCommodityParameterOptions.push(pushItem);
    }
    return additionalCommodityParameterOptions;
  },

  parametersCheckboxOptions: (state) => {
    const parametersCheckboxOptions = [];
    state.additionalCommodityParameters.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
        fieldTypeId: item.fieldTypeId,
        dropDown: item.dropDown,
        isInventoryEffective: item.isInventoryEffective,
      };
      parametersCheckboxOptions.push(pushItem);
    }
    return parametersCheckboxOptions;
  },

  accountTypeOptions: (state) => {
    const accountTypeOptions = [];
    state.accountTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      accountTypeOptions.push(pushItem);
    }
    return accountTypeOptions;
  },

  accountControlOptions: (state) => {
    const accountControlOptions = [];
    state.accountControls.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      accountControlOptions.push(pushItem);
    }
    return accountControlOptions;
  },

  accountActionOptions: (state) => {
    const accountActionOptions = [];
    state.accountActions.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      accountActionOptions.push(pushItem);
    }
    return accountActionOptions;
  },

  draftWareVoucherTypeOptions: (state) => {
    const draftWareVoucherTypeOptions = [];
    state.draftWareVoucherType.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
        isInternalUse: item.isInternalUse,
      };
      draftWareVoucherTypeOptions.push(pushItem);
    }
    return draftWareVoucherTypeOptions;
  },

  supplierOptions: (state) => {
    const supplierOptions = [];
    state.suppliers.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      supplierOptions.push(pushItem);
    }
    return supplierOptions;
  },

  cashiersOptions: (state) => {
    const cashiersOptions = [];
    state.cashiers.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      cashiersOptions.push(pushItem);
    }
    return cashiersOptions;
  },

  buyerOptions: (state) => {
    const buyerOptions = [];
    state.buyers.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      buyerOptions.push(pushItem);
    }
    return buyerOptions;
  },

  receiverOptions: (state) => {
    const receiverOptions = [];
    state.receivers.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      receiverOptions.push(pushItem);
    }
    return receiverOptions;
  },

  sbuTreeOptions: (state) => {
    return state.sbuTree;
  },

  wareCommodityOptions: (state) => {
    const wareCommodityOptions = [];
    state.wareCommodities.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
        fullText: [item.code, item.title, item.unitCountTitle]
          .filter((item) => item)
          .join(" | "),
        code: item.code,
        unitCountId: item.unitCountId,
        unitCountTitle: item.unitCountTitle,
        groupTitle: item.groupTitle || item.commodityGroupTitle,
      };
      wareCommodityOptions.push(pushItem);
    }
    return wareCommodityOptions;
  },

  destinationWareCommodityOptions: (state) => {
    const destinationWareCommodityOptions = [];
    state.destinationWareCommodities.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
        fullText: item.code + " | " + item.title + " | " + item.unitCountTitle,
        code: item.code,
        unitCountId: item.unitCountId,
        unitCountTitle: item.unitCountTitle,
        groupTitle: item.groupTitle || item.commodityGroupTitle,
      };
      destinationWareCommodityOptions.push(pushItem);
    }
    return destinationWareCommodityOptions;
  },

  positionInfoTreeOptions: (state) => {
    return state.positionInfoTree;
  },

  cartableOptions: (state) => {
    const cartableOptions = [];
    state.cartable.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      cartableOptions.push(pushItem);
    }
    return cartableOptions;
  },

  draftOptions: (state) => {
    const draftOptions = [];
    state.drafts.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.serial,
        dateLocal: item.dateLocal,
      };
      draftOptions.push(pushItem);
    }
    return draftOptions;
  },

  commodityUnitCountOptions: (state) => {
    const commodityUnitCountOptions = [];
    state.commodityUnitCounts.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
        coefficient: item.coefficient,
      };
      commodityUnitCountOptions.push(pushItem);
    }
    return commodityUnitCountOptions;
  },

  commodityParameters: (state) => {
    return state.commodityParameters;
  },

  commodityBatchOptions: (state) => {
    const commodityBatchOptions = [];
    state.commodityBatches.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.batchNumber,
        trackingCode: item.trackingCode,
        expireDate: item.expireDate,
        expireDateLocal: item.expireDateLocal,
        productionDate: item.productionDate,
        productionDateLocal: item.productionDateLocal,
      };
      commodityBatchOptions.push(pushItem);
    }
    return commodityBatchOptions;
  },

  itemGroupTree: (state) => {
    return state.itemGroupTree;
  },

  buyRequestList: (state) => {
    return state.buyRequests || [];
  },

  buyRequestOptions: (state) => {
    const buyRequestOptions = [];
    state.buyRequests.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.code,
        dateLocal: item.dateLocal,
        userName: item.userName,
        supplierName: item.supplierName,
        endUseLocation: item.endUseLocation,
      };
      buyRequestOptions.push(pushItem);
    }
    return buyRequestOptions;
  },

  vehicleTypeOptions: (state) => {
    const vehicleTypeOptions = [];
    state.vehicleTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      vehicleTypeOptions.push(pushItem);
    }
    return vehicleTypeOptions;
  },

  warehousingTypeOptions: (state) => {
    const warehousingTypeOptions = [];
    state.warehousingTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      warehousingTypeOptions.push(pushItem);
    }
    return warehousingTypeOptions;
  },

  tempReceiptOptions: (state) => {
    const tempReceiptOptions = [];
    state.tempReceipts.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      tempReceiptOptions.push(pushItem);
    }
    return tempReceiptOptions;
  },

  personClubGroups: (state) => {
    return state.personClubGroups;
  },
  personClubGroupOptions: (state) => {
    const personClubGroupOptions = [];
    state.personClubGroups.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      personClubGroupOptions.push(pushItem);
    }
    return personClubGroupOptions;
  },

  personClubs: (state) => {
    return state.personClubs;
  },
  personClubOptions: (state) => {
    const personClubOptions = [];
    state.personClubs.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      personClubOptions.push(pushItem);
    }
    return personClubOptions;
  },

  deliveryMethodOptions: (state) => {
    const deliveryMethodOptions = [];
    state.deliveryMethods.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      deliveryMethodOptions.push(pushItem);
    }
    return deliveryMethodOptions;
  },

  paymentMethodsOptions: (state) => {
    const paymentMethodsOptions = [];
    state.paymentMethods.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      paymentMethodsOptions.push(pushItem);
    }
    return paymentMethodsOptions;
  },

  occasionTypeOptions: (state) => {
    const occasionTypeOptions = [];
    state.occasionTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      occasionTypeOptions.push(pushItem);
    }
    return occasionTypeOptions;
  },

  feedBackTypesOptions: (state) => {
    const feedBackTypesOptions = [];
    state.feedBackTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      feedBackTypesOptions.push(pushItem);
    }
    return feedBackTypesOptions;
  },

  campaignTypeOptions: (state) => {
    const campaignTypeOptions = [];
    state.campaignTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      campaignTypeOptions.push(pushItem);
    }
    return campaignTypeOptions;
  },

  salesChannelOptions: (state) => {
    const salesChannelOptions = [];
    state.salesChannels.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      salesChannelOptions.push(pushItem);
    }
    return salesChannelOptions;
  },

  introducedTypeOptions: (state) => {
    const introducedTypeOptions = [];
    state.introducedTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      introducedTypeOptions.push(pushItem);
    }
    return introducedTypeOptions;
  },

  tagOptions: (state) => {
    const tagOptions = [];
    state.tags.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      tagOptions.push(pushItem);
    }
    return tagOptions;
  },

  processTypeOptions: (state) => {
    const processTypeOptions = [];
    state.processTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      processTypeOptions.push(pushItem);
    }
    return processTypeOptions;
  },

  processServiceTypeOptions: (state) => {
    const processServiceTypeOptions = [];
    state.processServiceTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      processServiceTypeOptions.push(pushItem);
    }
    return processServiceTypeOptions;
  },

  feedBackOptions: (state) => {
    const feedBackOptions = [];
    state.feedBacks.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      feedBackOptions.push(pushItem);
    }
    return feedBackOptions;
  },

  workStationOptions: (state) => {
    const workStationOptions = [];
    state.workStations.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      workStationOptions.push(pushItem);
    }
    return workStationOptions;
  },

  grades: (state) => {
    return state.grades;
  },
  gradeOptions: (state) => {
    const gradeOptions = [];
    state.grades.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
        color: item.color,
        personClubGroupId: item.personClubGroupId,
      };
      gradeOptions.push(pushItem);
    }
    return gradeOptions;
  },

  feedbackQuestionOptOptions: (state) => {
    const feedbackQuestionOptOptions = [];
    state.feedbackQuestionOptions.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      feedbackQuestionOptOptions.push(pushItem);
    }
    return feedbackQuestionOptOptions;
  },

  financialRatiosOptions: (state) => {
    const financialRatiosOptions = [];
    state.financialRatios.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
        code: item.code,
      };
      financialRatiosOptions.push(pushItem);
    }
    return financialRatiosOptions;
  },

  answerTypeOptions: (state) => {
    const answerTypeOptions = [];
    state.answerTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      answerTypeOptions.push(pushItem);
    }
    return answerTypeOptions;
  },

  currencyTypeOptions: (state) => {
    const currencyTypeOptions = [];
    state.currencyTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
        isDefault: item.isDefault,
      };
      currencyTypeOptions.push(pushItem);
    }
    return currencyTypeOptions;
  },

  smsTemplates: (state) => {
    return state.smsTemplates;
  },

  saleSettings: (state) => {
    return state.saleSettings;
  },

  smsTemplateOptions: (state) => {
    const smsTemplateOptions = [];
    state.smsTemplates.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      smsTemplateOptions.push(pushItem);
    }
    return smsTemplateOptions;
  },

  turnTypeOptions: (state) => {
    const turnTypeOptions = [];
    state.turnTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      turnTypeOptions.push(pushItem);
    }
    return turnTypeOptions;
  },

  chequeStatusTypeOptions: (state) => {
    const chequeStatusTypeOptions = [];
    state.chequeStatusTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      chequeStatusTypeOptions.push(pushItem);
    }
    return chequeStatusTypeOptions;
  },

  bankOptions: (state) => {
    const bankOptions = [];
    state.banks.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      bankOptions.push(pushItem);
    }
    return bankOptions;
  },

  bankBranchOptions: (state) => {
    const bankBranchOptions = [];
    state.bankBranchs.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      bankBranchOptions.push(pushItem);
    }
    return bankBranchOptions;
  },

  chequeTemplatesOptions: (state) => {
    const chequeTemplatesOptions = [];
    state.chequeTemplates.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      chequeTemplatesOptions.push(pushItem);
    }
    return chequeTemplatesOptions;
  },

  bankCashAccountOptions: (state) => {
    const bankCashAccountOptions = [];
    state.bankCashAccount.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
        // text: item.title +  ' - ' +  item.accountNo,
        cashierId: item.cashierId,
        accountInfoId: item.accountInfoId,
        isAccount: item.isAccount,
        accountNo: item.accountNo,
      };
      bankCashAccountOptions.push(pushItem);
    }
    return bankCashAccountOptions;
  },

  bankAccountOptions: (state) => {
    const bankAccountOptions = [];
    state.bankCashAccount.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title + " - " + item.accountNo,
        cashierId: item.cashierId,
        accountInfoId: item.accountInfoId,
        isAccount: item.isAccount,
        accountNo: item.accountNo,
      };
      bankAccountOptions.push(pushItem);
    }
    return bankAccountOptions;
  },

  voucherNoteTypeOptions: (state) => {
    const voucherNoteTypeOptions = [];
    state.voucherNoteTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      voucherNoteTypeOptions.push(pushItem);
    }
    return voucherNoteTypeOptions;
  },

  defaultVoucherDescriptionOptions: (state) => {
    const defaultVoucherDescriptionOptions = [];
    state.defaultVoucherDescriptions.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      defaultVoucherDescriptionOptions.push(pushItem);
    }
    return defaultVoucherDescriptionOptions;
  },

  requestTypeOptions: (state) => {
    const requestTypeOptions = [];
    state.requestType.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      requestTypeOptions.push(pushItem);
    }
    return requestTypeOptions;
  },

  chequeStatusOptions: (state) => {
    const chequeStatusOptions = [];
    state.chequeStatuses.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
        creditAccountInfoId: item.creditAccountInfoId,
        debtAccountInfoId: item.debtAccountInfoId,
      };
      chequeStatusOptions.push(pushItem);
    }
    return chequeStatusOptions;
  },

  voucherTemplateTypeOptions: (state) => {
    const voucherTemplateTypeOptions = [];
    state.voucherTemplateType.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      voucherTemplateTypeOptions.push(pushItem);
    }
    return voucherTemplateTypeOptions;
  },

  voucherTemplateKeyTypeOptions: (state) => {
    const voucherTemplateKeyTypeOptions = [];
    state.voucherTemplateKeyType.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      voucherTemplateKeyTypeOptions.push(pushItem);
    }
    return voucherTemplateKeyTypeOptions;
  },

  smsTypeOptions: (state) => {
    const smsTypeOptions = [];
    state.smsTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      smsTypeOptions.push(pushItem);
    }
    return smsTypeOptions;
  },

  transactionInfo: (state) => {
    return state.transactionInfo;
  },
  transactionInfoOptions: (state) => {
    const transactionInfoOptions = [];
    state.transactionInfo.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
        id: item.id,
        code: item.code,
        title: item.title,
        creditAccountId: item.creditAccountId,
        debtAccountId: item.debtAccountId,
      };
      transactionInfoOptions.push(pushItem);
    }
    return transactionInfoOptions;
  },

  parakCommodityGroup: (state) => {
    return state.parakCommodityGroup;
  },
  parakCommodityGroupOptions: (state) => {
    const parakCommodityGroupOptions = [];
    state.parakCommodityGroup.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
        code: item.code,
      };
      parakCommodityGroupOptions.push(pushItem);
    }
    return parakCommodityGroupOptions;
  },

  parakCommodities: (state) => {
    return state.parakCommodities;
  },
  parakCommoditiesOptions: (state) => {
    const parakCommoditiesOptions = [];
    state.parakCommodities.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
        code: item.code,
      };
      parakCommoditiesOptions.push(pushItem);
    }
    return parakCommoditiesOptions;
  },

  requestPaymentOptions: (state) => {
    const requestPaymentOptions = [];
    state.requestPayment.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.code + " | " + item.descriptionFor,
        price: item.price,
        descriptionFor: item.descriptionFor,
      };
      requestPaymentOptions.push(pushItem);
    }
    return requestPaymentOptions;
  },

  chequeBatchOptions: (state) => {
    const chequeBatchOptions = [];
    state.chequeBatches.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.chequeBatchId,
        text: item.batchCode,
      };
      chequeBatchOptions.push(pushItem);
    }
    return chequeBatchOptions;
  },

  dateTypeOptions: (state) => {
    const dateTypeOptions = [];
    state.dateTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      dateTypeOptions.push(pushItem);
    }
    return dateTypeOptions;
  },

  settingDropdownCache: (state) => {
    return state.settingDropdownCache;
  },

  packageTypeOptions: (state) => {
    const packageTypeOptions = [];
    state.packageTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      packageTypeOptions.push(pushItem);
    }
    return packageTypeOptions;
  },

  MRPProcessTypeOptions: (state) => {
    const MRPProcessTypeOptions = [];
    state.MRPProcessTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      MRPProcessTypeOptions.push(pushItem);
    }
    return MRPProcessTypeOptions;
  },

  subMRPProcessTypeOptions: (state) => {
    const subMRPProcessTypeOptions = [];
    state.subMRPProcessTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      subMRPProcessTypeOptions.push(pushItem);
    }
    return subMRPProcessTypeOptions;
  },

  excelSampleTypeOptions: (state) => {
    const excelSampleTypeOptions = [];
    state.excelSampleType.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      excelSampleTypeOptions.push(pushItem);
    }
    return excelSampleTypeOptions;
  },

  excelSampleDetailTypeOptions: (state) => {
    const excelSampleDetailTypeOptions = [];
    state.excelSampleDetailType.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.key,
        text: item.title,
      };
      excelSampleDetailTypeOptions.push(pushItem);
    }
    return excelSampleDetailTypeOptions;
  },

  excelSampleDetailInformationTypeOptions: (state) => {
    const excelSampleDetailInformationTypeOptions = [];
    state.excelSampleDetailInformationType.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      excelSampleDetailInformationTypeOptions.push(pushItem);
    }
    return excelSampleDetailInformationTypeOptions;
  },

  excelSampleDetailTurnIntoTypeOptions: (state) => {
    const excelSampleDetailTurnIntoTypeOptions = [];
    state.excelSampleDetailTurnIntoType.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      excelSampleDetailTurnIntoTypeOptions.push(pushItem);
    }
    return excelSampleDetailTurnIntoTypeOptions;
  },

  receiveChequeFilterOptions: (state) => {
    const receiveChequeFilterOptions = [];
    state.receiveChequeFilters.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      receiveChequeFilterOptions.push(pushItem);
    }
    return receiveChequeFilterOptions;
  },

  paymentChequeFilterOptions: (state) => {
    const paymentChequeFilterOptions = [];
    state.paymentChequeFilters.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      paymentChequeFilterOptions.push(pushItem);
    }
    return paymentChequeFilterOptions;
  },

  receiptOptions: (state) => {
    const receiptOptions = [];
    state.receipts.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.serial,
        dateLocal: item.dateLocal,
      };
      receiptOptions.push(pushItem);
    }
    return receiptOptions;
  },

  sprintOptions: (state) => {
    const sprintOptions = [];
    state.sprints.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      sprintOptions.push(pushItem);
    }
    return sprintOptions;
  },

  produceOrderOptions: (state) => {
    const produceOrderOptions = [];
    state.produceOrders.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.code,
        count: item.count,
        commodityId: item.commodityId,
        subProcessTypeId: item.subProcessTypeId,
        coilNumber: item.productionReportCoilNumber,
      };
      produceOrderOptions.push(pushItem);
    }
    return produceOrderOptions;
  },

  coilCertificateOptions: (state) => {
    const coilCertificateOptions = [];
    state.coilCertificates.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      coilCertificateOptions.push(pushItem);
    }
    return coilCertificateOptions;
  },

  monthlyComparisonReceiveChequeFilterOptions: (state) => {
    const monthlyComparisonReceiveChequeFilterOptions = [];
    state.monthlyComparisonReceiveChequeFilters.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      monthlyComparisonReceiveChequeFilterOptions.push(pushItem);
    }
    return monthlyComparisonReceiveChequeFilterOptions;
  },

  monthlyComparisonPaymentChequeFilterOptions: (state) => {
    const monthlyComparisonPaymentChequeFilterOptions = [];
    state.monthlyComparisonPaymentChequeFilters.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      monthlyComparisonPaymentChequeFilterOptions.push(pushItem);
    }
    return monthlyComparisonPaymentChequeFilterOptions;
  },

  summaryPaymentChequeFilterOptions: (state) => {
    const summaryPaymentChequeFilterOptions = [];
    state.summaryPaymentChequeFilters.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      summaryPaymentChequeFilterOptions.push(pushItem);
    }
    return summaryPaymentChequeFilterOptions;
  },

  summaryReceiveChequeFilterOptions: (state) => {
    const summaryReceiveChequeFilterOptions = [];
    state.summaryReceiveChequeFilters.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      summaryReceiveChequeFilterOptions.push(pushItem);
    }
    return summaryReceiveChequeFilterOptions;
  },

  casterProduceOrderOptions: (state) => {
    const casterProduceOrderOptions = [];
    state.casterProduceOrders.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.code,
        count: item.count,
        commodityId: item.commodityId,
      };
      casterProduceOrderOptions.push(pushItem);
    }
    return casterProduceOrderOptions;
  },

  productionReportOptions: (state) => {
    const productionReportOptions = [];
    state.productionReports.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.code,
      };
      productionReportOptions.push(pushItem);
    }
    return productionReportOptions;
  },

  workStationStatusOptions: (state) => {
    const workStationStatusOptions = [];
    state.workStationStatuses.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      workStationStatusOptions.push(pushItem);
    }
    return workStationStatusOptions;
  },

  inputTypeOptions: (state) => {
    const inputTypeOptions = [];
    state.inputTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      inputTypeOptions.push(pushItem);
    }
    return inputTypeOptions;
  },

  productionGroupOptions: (state) => {
    const productionGroupOptions = [];
    state.productionGroups.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      productionGroupOptions.push(pushItem);
    }
    return productionGroupOptions;
  },

  purchaseContractOptions: (state) => {
    const purchaseContractOptions = [];
    state.purchaseContracts.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      purchaseContractOptions.push(pushItem);
    }
    return purchaseContractOptions;
  },

  saleTypeOptions: (state) => {
    const saleTypeOptions = [];
    state.saleTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      saleTypeOptions.push(pushItem);
    }
    return saleTypeOptions;
  },

  orderCommoditiesOptions: (state) => {
    const orderCommoditiesOptions = [];
    state.orderCommodities.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.size,
        pn: item.pn,
      };
      orderCommoditiesOptions.push(pushItem);
    }
    return orderCommoditiesOptions;
  },

  orderCommodityStatusOptions: (state) => {
    const orderCommodityStatusOptions = [];
    state.orderCommodityStatus.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      orderCommodityStatusOptions.push(pushItem);
    }
    return orderCommodityStatusOptions;
  },

  orderBomOptions: (state) => {
    const orderBomOptions = [];
    state.orderBoms.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      orderBomOptions.push(pushItem);
    }
    return orderBomOptions;
  },

  productionGroupSupplierOptions: (state) => {
    const productionGroupSupplierOptions = [];
    state.productionGroupSuppliers.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      productionGroupSupplierOptions.push(pushItem);
    }
    return productionGroupSupplierOptions;
  },

  agentOptions: (state) => {
    const agentOptions = [];
    state.agents.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      agentOptions.push(pushItem);
    }
    return agentOptions;
  },

  salesManagerOptions: (state) => {
    const salesManagerOptions = [];
    state.salesManagers.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      salesManagerOptions.push(pushItem);
    }
    return salesManagerOptions;
  },

  purchaseManagerOptions: (state) => {
    const purchaseManagerOptions = [];
    state.purchaseManagers.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      purchaseManagerOptions.push(pushItem);
    }
    return purchaseManagerOptions;
  },

  distributorOptions: (state) => {
    const distributorOptions = [];
    state.distributors.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      distributorOptions.push(pushItem);
    }
    return distributorOptions;
  },

  driverOptions: (state) => {
    const driverOptions = [];
    state.drivers.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      driverOptions.push(pushItem);
    }
    return driverOptions;
  },

  sellerOptions: (state) => {
    const sellerOptions = [];
    state.sellers.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      sellerOptions.push(pushItem);
    }
    return sellerOptions;
  },

  employerOptions: (state) => {
    const employerOptions = [];
    state.employers.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      employerOptions.push(pushItem);
    }
    return employerOptions;
  },

  employeOptions: (state) => {
    const employeOptions = [];
    state.employees.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      employeOptions.push(pushItem);
    }
    return employeOptions;
  },

  contractorOptions: (state) => {
    const contractorOptions = [];
    state.contractors.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      contractorOptions.push(pushItem);
    }
    return contractorOptions;
  },
  bomSettingOptions: (state) => {
    const bomSettingOptions = [];
    state.bomSetting.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
        valueOption: item.value,
      };
      bomSettingOptions.push(pushItem);
    }
    return bomSettingOptions;
  },

  parakPersonDealTypesOptions: (state) => {
    const parakPersonDealTypesOptions = [];
    state.parakPersonDealTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      parakPersonDealTypesOptions.push(pushItem);
    }
    return parakPersonDealTypesOptions;
  },

  parakCottageOptions: (state) => {
    const parakCottageOptions = [];
    state.parakCottage.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.number,
      };
      parakCottageOptions.push(pushItem);
    }
    return parakCottageOptions;
  },

  parakSettlementTypeOptions: (state) => {
    const parakSettlementTypeOptions = [];
    state.parakSettlementType.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      parakSettlementTypeOptions.push(pushItem);
    }
    return parakSettlementTypeOptions;
  },

  parakOrderOperationsOptions: (state) => {
    const parakOrderOperationsOptions = [];
    state.parakOrderOperations.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      parakOrderOperationsOptions.push(pushItem);
    }
    return parakOrderOperationsOptions;
  },

  parakPurchasesOptions: (state) => {
    const parakPurchasesOptions = [];
    state.parakPurchases.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.allocationNumber,
      };
      parakPurchasesOptions.push(pushItem);
    }
    return parakPurchasesOptions;
  },

  personAddressOptions: (state) => {
    const personAddressOptions = [];
    state.personAddress.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        nationalCode: item.nationalId,
        phone: item.phone,
        mobile: item.personMobileNumber,
        phoneNumber: item.personPhone,
        country: item.countryId,
        province: item.provinceId,
        city: item.cityId,
        zipCode: item.zipCode,
        address: item.address,
        text: item.title,
      };
      personAddressOptions.push(pushItem);
    }
    return personAddressOptions;
  },

  parakOrdersOptions: (state) => {
    const parakOrdersOptions = [];
    state.parakOrders.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        number: item.number,
        date: item.dateLocal,
        text: item.dateLocal + " - " + item.number,
      };
      parakOrdersOptions.push(pushItem);
    }
    return parakOrdersOptions;
  },

  parakVoucherTypeOptions: (state) => {
    const parakVoucherTypeOptions = [];
    state.parakVoucherType.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      parakVoucherTypeOptions.push(pushItem);
    }
    return parakVoucherTypeOptions;
  },

  parakLadingOperationOptions: (state) => {
    const parakLadingOperationOptions = [];
    state.parakLadingOperation.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      parakLadingOperationOptions.push(pushItem);
    }
    return parakLadingOperationOptions;
  },

  commodityAdditionalInfoOptions: (state) => {
    const commodityAdditionalInfoOptions = [];
    state.commodityAdditionalInfos.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.commodityTitle,
        commodityId: item.commodityId,
        code: item.commodityCode,
        pn: item.pn,
        size: item.size,
        unitCountId: item.unitCountId,
        unitCountTitle: item.unitCountTitle,
      };
      commodityAdditionalInfoOptions.push(pushItem);
    }
    return commodityAdditionalInfoOptions;
  },

  addMinusTypeOptions: (state) => {
    const addMinusTypeOptions = [];
    state.addMinusType.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      addMinusTypeOptions.push(pushItem);
    }
    return addMinusTypeOptions;
  },

  saleExcelSampleTypeOptions: (state) => {
    const saleExcelSampleTypeOptions = [];
    state.saleExcelSampleType.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      saleExcelSampleTypeOptions.push(pushItem);
    }
    return saleExcelSampleTypeOptions;
  },

  saleExcelSampleDetailTypeOptions: (state) => {
    const saleExcelSampleDetailTypeOptions = [];
    state.saleExcelSampleDetailType.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      saleExcelSampleDetailTypeOptions.push(pushItem);
    }
    return saleExcelSampleDetailTypeOptions;
  },

  cancelStatusOptions: (state) => {
    const cancelStatusOptions = [];
    state.cancelStatuses.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      cancelStatusOptions.push(pushItem);
    }
    return cancelStatusOptions;
  },

  saleFactorTypeOptions: (state) => {
    const saleFactorTypeOptions = [];
    state.saleFactorType.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      saleFactorTypeOptions.push(pushItem);
    }
    return saleFactorTypeOptions;
  },

  returnedFactorTypeOptions: (state) => {
    const returnedFactorTypeOptions = [];
    state.returnedFactorTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      returnedFactorTypeOptions.push(pushItem);
    }
    return returnedFactorTypeOptions;
  },

  saleSaleTypesOptions: (state) => {
    const saleSaleTypesOptions = [];
    state.saleSaleTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      saleSaleTypesOptions.push(pushItem);
    }
    return saleSaleTypesOptions;
  },

  salePricePolicesTypesOptions: (state) => {
    const salePricePolicesTypesOptions = [];
    state.salePricePolicesTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      salePricePolicesTypesOptions.push(pushItem);
    }
    return salePricePolicesTypesOptions;
  },

  saleCancelStatusOptions: (state) => {
    const saleCancelStatusOptions = [];
    state.saleCancelStatus.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      saleCancelStatusOptions.push(pushItem);
    }
    return saleCancelStatusOptions;
  },

  saleVoucherStatusOptions: (state) => {
    const saleVoucherStatusOptions = [];
    state.saleVoucherStatus.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      saleVoucherStatusOptions.push(pushItem);
    }
    return saleVoucherStatusOptions;
  },

  salePricePolicyOptions: (state) => {
    const salePricePolicyOptions = [];
    state.salePricePolices.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      salePricePolicyOptions.push(pushItem);
    }
    return salePricePolicyOptions;
  },

  saleAddMinuses: (state) => {
    return state.saleAddMinuses;
  },
  saleAddMinusesOptions: (state) => {
    const saleAddMinusesOptions = [];
    state.saleAddMinuses.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
        typeId: item.typeId,
        isPercentage: item.isPercentage,
        amount: item.amount,
      };
      saleAddMinusesOptions.push(pushItem);
    }
    return saleAddMinusesOptions;
  },

  receiveAndPayOptions: (state) => {
    const receiveAndPayOptions = [];
    state.receiveAndPay.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
        accountInfoId: item.accountInfoId,
      };
      receiveAndPayOptions.push(pushItem);
    }
    return receiveAndPayOptions;
  },

  accountConfigOptions: (state) => {
    const accountConfigOptions = [];
    state.accountConfigs.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      accountConfigOptions.push(pushItem);
    }
    return accountConfigOptions;
  },

  nodeDepthOptions: (state) => {
    const nodeDepthOptions = [];
    state.accountConfigs.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.nodeDepth,
        text: item.title,
      };
      nodeDepthOptions.push(pushItem);
    }
    return nodeDepthOptions;
  },

  searchTypeOptions: (state) => {
    const searchTypeOptions = [];
    state.searchTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      searchTypeOptions.push(pushItem);
    }
    return searchTypeOptions;
  },

  documentTypeOptions: (state) => {
    const documentTypeOptions = [];
    state.documentTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      documentTypeOptions.push(pushItem);
    }
    return documentTypeOptions;
  },

  saleAgentOptions: (state) => {
    return state.saleAgents
      .map((item) => {
        const person = state.persons.find((p) => p.id === item.personId);
        if (person) {
          return {
            value: item.id,
            text: person.title,
          };
        }
        return null;
      })
      .filter((option) => option !== null);
  },

  buyFactorTypesOptions: (state) => {
    const buyFactorTypesOptions = [];
    state.buyFactorTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      buyFactorTypesOptions.push(pushItem);
    }
    return buyFactorTypesOptions;
  },

  factorFormatsOptions: (state) => {
    const factorFormatsOptions = [];
    state.factorFormats.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      factorFormatsOptions.push(pushItem);
    }
    return factorFormatsOptions;
  },

  saleSaleManagerOptions: (state) => {
    return state.saleSaleManager
      .map((item) => {
        const person = state.persons.find((p) => p.id === item.personId);
        if (person) {
          return {
            value: item.id,
            text: person.title,
          };
        }
        return null;
      })
      .filter((option) => option !== null);
  },

  saleCommissionTypesOptions: (state) => {
    const saleCommissionTypesOptions = [];
    state.saleCommissionTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      saleCommissionTypesOptions.push(pushItem);
    }
    return saleCommissionTypesOptions;
  },

  scmsBuyTypesOptions: (state) => {
    const scmsBuyTypesOptions = [];
    state.scmsBuyTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      scmsBuyTypesOptions.push(pushItem);
    }
    return scmsBuyTypesOptions;
  },

  buyAddMinusesOptions: (state) => {
    const buyAddMinusesOptions = [];
    state.buyAddMinuses.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
        typeId: item.typeId,
        isPercentage: item.isPercentage,
        amount: item.amount,
      };
      buyAddMinusesOptions.push(pushItem);
    }
    return buyAddMinusesOptions;
  },

  listSetting: (state) => {
    return state.listSetting;
  },

  saleFactorOptions: (state) => {
    const saleFactorOptions = [];
    state.saleFactors.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.code,
        dateLocal: item.dateLocal,
      };
      saleFactorOptions.push(pushItem);
    }
    return saleFactorOptions;
  },

  voucherOptions: (state) => {
    const voucherOptions = [];
    state.vouchers.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.number,
      };
      voucherOptions.push(pushItem);
    }
    return voucherOptions;
  },

  reportVoucherOptions: (state) => {
    const reportVoucherOptions = [];
    state.reportVouchers.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.number,
        financialYear: item.fiscalYearTitle,
        voucherTypeId: item.voucherTypeId,
      };
      reportVoucherOptions.push(pushItem);
    }
    return reportVoucherOptions;
  },

  returnBuyFactorOptions: (state) => {
    const returnBuyFactorOptions = [];
    state.returnBuyFactors.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.code,
        dateLocal: item.dateLocal,
      };
      returnBuyFactorOptions.push(pushItem);
    }
    return returnBuyFactorOptions;
  },

  transferCommodityOptions: (state) => {
    const transferCommodityOptions = [];
    state.transferCommodites.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      transferCommodityOptions.push(pushItem);
    }
    return transferCommodityOptions;
  },

  warehousingOptions: (state) => {
    const warehousingOptions = [];
    state.warehousings.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      warehousingOptions.push(pushItem);
    }
    return warehousingOptions;
  },

  productionOptions: (state) => {
    const productionOptions = [];
    state.productions.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      productionOptions.push(pushItem);
    }
    return productionOptions;
  },

  receiptCartableConfirmOptions: (state) => {
    const receiptCartableConfirmOptions = [];
    state.receiptCartableConfirm.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.priority,
        text: item.title,
      };
      receiptCartableConfirmOptions.push(pushItem);
    }
    return receiptCartableConfirmOptions;
  },

  draftCartableConfirmOptions: (state) => {
    const draftCartableConfirmOptions = [];
    state.draftCartableConfirm.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.priority,
        text: item.title,
      };
      draftCartableConfirmOptions.push(pushItem);
    }
    return draftCartableConfirmOptions;
  },

  saleCartableConfirmOptions: (state) => {
    const saleCartableConfirmOptions = [];
    state.saleCartableConfirm.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.priority,
        text: item.title,
      };
      saleCartableConfirmOptions.push(pushItem);
    }
    return saleCartableConfirmOptions;
  },

  salesReturnCartableConfirmOptions: (state) => {
    const salesReturnCartableConfirmOptions = [];
    state.salesReturnCartableConfirm.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.priority,
        text: item.title,
      };
      salesReturnCartableConfirmOptions.push(pushItem);
    }
    return salesReturnCartableConfirmOptions;
  },

  buyFactorCartableConfirmOptions: (state) => {
    const buyFactorCartableConfirmOptions = [];
    state.buyFactorCartableConfirm.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.priority,
        text: item.title,
      };
      buyFactorCartableConfirmOptions.push(pushItem);
    }
    return buyFactorCartableConfirmOptions;
  },

  buyReturnCartableConfirmOptions: (state) => {
    const buyReturnCartableConfirmOptions = [];
    state.buyReturnCartableConfirm.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.priority,
        text: item.title,
      };
      buyReturnCartableConfirmOptions.push(pushItem);
    }
    return buyReturnCartableConfirmOptions;
  },

  reqBuyCartableConfirmOptions: (state) => {
    const reqBuyCartableConfirmOptions = [];
    state.reqBuyCartableConfirm.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.priority,
        text: item.title,
      };
      reqBuyCartableConfirmOptions.push(pushItem);
    }
    return reqBuyCartableConfirmOptions;
  },

  reqPaymentCartableConfirmOptions: (state) => {
    const reqPaymentCartableConfirmOptions = [];
    state.reqPaymentCartableConfirm.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.priority,
        text: item.title,
      };
      reqPaymentCartableConfirmOptions.push(pushItem);
    }
    return reqPaymentCartableConfirmOptions;
  },

  chequePaymentCartableConfirmOptions: (state) => {
    const chequePaymentCartableConfirmOptions = [];
    state.chequePaymentCartableConfirm.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.priority,
        text: item.title,
      };
      chequePaymentCartableConfirmOptions.push(pushItem);
    }
    return chequePaymentCartableConfirmOptions;
  },

  receiveChequeCartableConfirmOptions: (state) => {
    const receiveChequeCartableConfirmOptions = [];
    state.receiveChequeCartableConfirm.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.priority,
        text: item.title,
      };
      receiveChequeCartableConfirmOptions.push(pushItem);
    }
    return receiveChequeCartableConfirmOptions;
  },

  currentPersonInVoucherDetailOptions: (state) => {
    const currentPersonInVoucherDetailOptions = [];
    state.currentPersonInVoucherDetails.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        code: item.code,
        text: item.fullName,
      };
      currentPersonInVoucherDetailOptions.push(pushItem);
    }
    return currentPersonInVoucherDetailOptions;
  },

  buyFactorOptions: (state) => {
    const buyFactorOptions = [];
    state.buyFactors.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.code,
        dateLocal: item.dateLocal,
      };
      buyFactorOptions.push(pushItem);
    }
    return buyFactorOptions;
  },

  returnSaleFactorOptions: (state) => {
    const returnSaleFactorOptions = [];
    state.returnSaleFactors.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.code,
        dateLocal: item.dateLocal,
      };
      returnSaleFactorOptions.push(pushItem);
    }
    return returnSaleFactorOptions;
  },

  transactionTypeOptions: (state) => {
    const transactionTypeOptions = [];
    state.transactionTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      transactionTypeOptions.push(pushItem);
    }
    return transactionTypeOptions;
  },

  personOfficeReportTypeOptions: (state) => {
    const personOfficeReportTypeOptions = [];
    state.personOfficeReportTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      personOfficeReportTypeOptions.push(pushItem);
    }
    return personOfficeReportTypeOptions;
  },

  inspectionLevelOptions: (state) => {
    const inspectionLevelOptions = [];
    state.inspectionLevels.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      inspectionLevelOptions.push(pushItem);
    }
    return inspectionLevelOptions;
  },

  dateTimeFormatOptions: (state) => {
    const dateTimeFormatOptions = [];
    state.dateTimeFormats.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      dateTimeFormatOptions.push(pushItem);
    }
    return dateTimeFormatOptions;
  },

  monthlyAccountingVoucherKeyTypeOptions: (state) => {
    const monthlyAccountingVoucherKeyTypeOptions = [];
    state.monthlyAccountingVoucherKeyTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      monthlyAccountingVoucherKeyTypeOptions.push(pushItem);
    }
    return monthlyAccountingVoucherKeyTypeOptions;
  },

  managementCartableOptions: (state) => {
    const managementCartableOptions = [];
    state.managementCartable.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      managementCartableOptions.push(pushItem);
    }
    return managementCartableOptions;
  },

  hardnessOptions: (state) => {
    const hardnessOptions = [];
    state.hardnesses.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      hardnessOptions.push(pushItem);
    }
    return hardnessOptions;
  },

  productSurfaceOptions: (state) => {
    const productSurfaceOptions = [];
    state.productSurfaces.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      productSurfaceOptions.push(pushItem);
    }
    return productSurfaceOptions;
  },

  usageGroupOptions: (state) => {
    const usageGroupOptions = [];
    state.usageGroups.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      usageGroupOptions.push(pushItem);
    }
    return usageGroupOptions;
  },

  foilUsageOptions: (state) => {
    const foilUsageOptions = [];
    state.foilUsages.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      foilUsageOptions.push(pushItem);
    }
    return foilUsageOptions;
  },

  innerCoreDiameterOptions: (state) => {
    const innerCoreDiameterOptions = [];
    state.innerCoreDiameters.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      innerCoreDiameterOptions.push(pushItem);
    }
    return innerCoreDiameterOptions;
  },

  report: (state) => {
    return state.report;
  },

  reportDropDown: (state) => {
    return state.reportDropDown;
  },

  reportDropDownOptions: (state) => {
    const reportDropDownOptions = [];
    state.reportDropDown.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      reportDropDownOptions.push(pushItem);
    }
    return reportDropDownOptions;
  },

  exportFileFormatTypeOptions: (state) => {
    const exportFileFormatTypeOptions = [];
    state.exportFileFormatTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      exportFileFormatTypeOptions.push(pushItem);
    }
    return exportFileFormatTypeOptions;
  },

  turnTypeReceivedOptions: (state) => {
    const turnTypeReceivedOptions = [];
    state.turnTypeReceived.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      turnTypeReceivedOptions.push(pushItem);
    }
    return turnTypeReceivedOptions;
  },

  turnTypePayableOptions: (state) => {
    const turnTypePayableOptions = [];
    state.turnTypePayable.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      turnTypePayableOptions.push(pushItem);
    }
    return turnTypePayableOptions;
  },

  turnCashTypesOptions: (state) => {
    const turnCashTypesOptions = [];
    state.turnCashTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      turnCashTypesOptions.push(pushItem);
    }
    return turnCashTypesOptions;
  },

  receiptPaymentSubjectTypeOptions: (state) => {
    const receiptPaymentSubjectTypeOptions = [];
    state.receiptPaymentSubjectTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      receiptPaymentSubjectTypeOptions.push(pushItem);
    }
    return receiptPaymentSubjectTypeOptions;
  },

  receiptPaymentSubjectOptions: (state) => {
    const receiptPaymentSubjectOptions = [];
    state.receiptPaymentSubjects.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      receiptPaymentSubjectOptions.push(pushItem);
    }
    return receiptPaymentSubjectOptions;
  },

  chequeSayadAndBankInfo: (state) => {
    return state.chequeSayadAndBankInfo;
  },

  saleDiscountTypeOptions: (state) => {
    const saleDiscountTypeOptions = [];
    state.saleDiscountTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      saleDiscountTypeOptions.push(pushItem);
    }
    return saleDiscountTypeOptions;
  },

  saleProcessOptions: (state) => {
    const saleProcessOptions = [];
    state.saleProcesses.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      saleProcessOptions.push(pushItem);
    }
    return saleProcessOptions;
  },

  issueTrackingTypeOptions: (state) => {
    const issueTrackingTypeOptions = [];
    state.issueTrackingTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      issueTrackingTypeOptions.push(pushItem);
    }
    return issueTrackingTypeOptions;
  },

  trackingNumbersOptions: (state) => {
    const trackingNumbersOptions = [];
    state.trackingNumbersByChequeNumber.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.trackingNumber,
        accountNo: item.accountNo,
        bankBranchTitle: item.bankBranchTitle,
        bankTitle: item.bankTitle,
        chequeBatchId: item.chequeBatchId,
      };
      trackingNumbersOptions.push(pushItem);
    }
    return trackingNumbersOptions;
  },

  goalOptions: (state) => {
    const goalOptions = [];
    state.goals.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      goalOptions.push(pushItem);
    }
    return goalOptions;
  },

  campaignOptions: (state) => {
    const campaignOptions = [];
    state.campaigns.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      campaignOptions.push(pushItem);
    }
    return campaignOptions;
  },

  leadSourceOptions: (state) => {
    const leadSourceOptions = [];
    state.leadSources.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      leadSourceOptions.push(pushItem);
    }
    return leadSourceOptions;
  },

  leadStatusOptions: (state) => {
    const leadStatusOptions = [];
    state.leadStatuses.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      leadStatusOptions.push(pushItem);
    }
    return leadStatusOptions;
  },

  leadPropertyOptions: (state) => {
    const leadPropertyOptions = [];
    state.leadPropertys.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      leadPropertyOptions.push(pushItem);
    }
    return leadPropertyOptions;
  },

  leadTypeOptions: (state) => {
    const leadTypeOptions = [];
    state.leadTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      leadTypeOptions.push(pushItem);
    }
    return leadTypeOptions;
  },

  leadNotChanceOptions: (state) => {
    const leadNotChanceOptions = [];
    state.leadNotChances.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.fullName,
      };
      leadNotChanceOptions.push(pushItem);
    }
    return leadNotChanceOptions;
  },

  chanceSaleStatuseOptions: (state) => {
    const chanceSaleStatuseOptions = [];
    state.chanceSaleStatuses.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      chanceSaleStatuseOptions.push(pushItem);
    }
    return chanceSaleStatuseOptions;
  },

  campaignStatusOptions: (state) =>
    state.campaignStatuses.map((item) => ({
      value: item.id,
      text: item.title,
    })),

  campaignExecutionPhaseOptions: (state) =>
    state.campaignExecutionPhases.map((item) => ({
      value: item.id,
      text: item.title,
    })),

  ageGroupOptions: (state) =>
    state.ageGroups.map((item) => ({ value: item.id, text: item.title })),

  chanceTypeOptions: (state) => {
    const chanceTypeOptions = [];
    state.chanceTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      chanceTypeOptions.push(pushItem);
    }
    return chanceTypeOptions;
  },

  chanceStatusOptions: (state) =>
    state.chanceStatuses.map((item) => ({ value: item.id, text: item.title })),

  chanceResultOptions: (state) =>
    state.chanceResults.map((item) => ({ value: item.id, text: item.title })),

  saleLineOptions: (state) =>
    state.saleLines.map((item) => ({
      value: item.id,
      text: item.title,
      commodityGroupId: item.commodityGroupId,
    })),

  saleLineStageOptions: (state) =>
    state.saleLineStages.map((item) => ({
      value: item.id,
      text: item.title,
      typeId: item.typeId ?? item.saleStageTypeId ?? null,
      typeTitle: item.typeTitle || item.saleStageTypeTitle || null,
    })),

  saleStageTypeOptions: (state) =>
    state.saleStageTypes.map((item) => ({ value: item.id, text: item.title })),

  chancePriorityOptions: (state) => {
    const chancePriorityOptions = [];
    state.chancePrioritys.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      chancePriorityOptions.push(pushItem);
    }
    return chancePriorityOptions;
  },

  failedSaleReasonOptions: (state) =>
    state.failedSaleReasons.map((item) => ({
      value: item.id,
      text: item.title,
    })),

  workShiftOptions: (state) => {
    const workShiftOptions = [];
    state.workShifts.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      workShiftOptions.push(pushItem);
    }
    return workShiftOptions;
  },

  strengthWeaknessOptions: (state) => {
    const strengthWeaknessOptions = [];
    state.strengthWeaknesses.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      strengthWeaknessOptions.push(pushItem);
    }
    return strengthWeaknessOptions;
  },

  strengthWeaknessTypeOptions: (state) => {
    const strengthWeaknessTypeOptions = [];
    state.strengthWeaknessTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      strengthWeaknessTypeOptions.push(pushItem);
    }
    return strengthWeaknessTypeOptions;
  },

  furnaceOptions: (state) => {
    const furnaceOptions = [];
    state.furnaces.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      furnaceOptions.push(pushItem);
    }
    return furnaceOptions;
  },

  furnacePlacementOptions: (state) => {
    const furnacePlacementOptions = [];
    state.furnacePlacements.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      furnacePlacementOptions.push(pushItem);
    }
    return furnacePlacementOptions;
  },

  orderDateTypeOptions: (state) => {
    const orderDateTypeOptions = [];
    state.orderDateTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      orderDateTypeOptions.push(pushItem);
    }
    return orderDateTypeOptions;
  },

  projectTypeOptions: (state) => {
    const projectTypeOptions = [];
    state.projectTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      projectTypeOptions.push(pushItem);
    }
    return projectTypeOptions;
  },

  projectExecutionPhaseOptions: (state) => {
    const projectExecutionPhaseOptions = [];
    state.projectExecutionPhases.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      projectExecutionPhaseOptions.push(pushItem);
    }
    return projectExecutionPhaseOptions;
  },

  leadOptions: (state) => {
    const leadOptions = [];
    state.leads.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: (item.brand ? item.brand + " | " : "") + item.fullName,
      };
      leadOptions.push(pushItem);
    }
    return leadOptions;
  },

  projectOptions: (state) => {
    const projectOptions = [];
    state.projects.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      projectOptions.push(pushItem);
    }
    return projectOptions;
  },

  workDescriptionOptions: (state) => {
    const workDescriptionOptions = [];
    state.workDescriptions.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      workDescriptionOptions.push(pushItem);
    }
    return workDescriptionOptions;
  },

  taskStatusOptions: (state) => {
    const taskStatusOptions = [];
    state.taskStatuses.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      taskStatusOptions.push(pushItem);
    }
    return taskStatusOptions;
  },

  taskCategoryOptions: (state) => {
    const taskCategoryOptions = [];
    state.taskCategorys.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      taskCategoryOptions.push(pushItem);
    }
    return taskCategoryOptions;
  },

  noteCategoryOptions: (state) => {
    const noteCategoryOptions = [];
    state.noteCategorys.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      noteCategoryOptions.push(pushItem);
    }
    return noteCategoryOptions;
  },

  noteSubjectOptions: (state) => {
    const noteSubjectOptions = [];
    state.noteSubjects.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      noteSubjectOptions.push(pushItem);
    }
    return noteSubjectOptions;
  },

  noteStatusOptions: (state) => {
    const noteStatusOptions = [];
    state.noteStatuses.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      noteStatusOptions.push(pushItem);
    }
    return noteStatusOptions;
  },

  hamyarRequestTypeOptions: (state) => {
    const hamyarRequestTypeOptions = [];
    state.hamyarRequestTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      hamyarRequestTypeOptions.push(pushItem);
    }
    return hamyarRequestTypeOptions;
  },

  requestStatusOptions: (state) => {
    const requestStatusOptions = [];
    state.requestStatuses.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      requestStatusOptions.push(pushItem);
    }
    return requestStatusOptions;
  },

  serviceSupportSubjectOptions: (state) => {
    const serviceSupportSubjectOptions = [];
    state.serviceSupportSubjects.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      serviceSupportSubjectOptions.push(pushItem);
    }
    return serviceSupportSubjectOptions;
  },

  serviceSupportStatusOptions: (state) => {
    const serviceSupportStatusOptions = [];
    state.serviceSupportStatuses.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      serviceSupportStatusOptions.push(pushItem);
    }
    return serviceSupportStatusOptions;
  },

  serviceSupportCategoryOptions: (state) => {
    const serviceSupportCategoryOptions = [];
    state.serviceSupportCategories.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      serviceSupportCategoryOptions.push(pushItem);
    }
    return serviceSupportCategoryOptions;
  },

  serviceSupportAnnouncementTypeOptions: (state) => {
    const serviceSupportAnnouncementTypeOptions = [];
    state.serviceSupportAnnouncementTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      serviceSupportAnnouncementTypeOptions.push(pushItem);
    }
    return serviceSupportAnnouncementTypeOptions;
  },

  serviceSupportActionTypeOptions: (state) => {
    const serviceSupportActionTypeOptions = [];
    state.serviceSupportActionTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      serviceSupportActionTypeOptions.push(pushItem);
    }
    return serviceSupportActionTypeOptions;
  },

  serviceSupportOptions: (state) => {
    const serviceSupportOptions = [];
    state.serviceSupports.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      serviceSupportOptions.push(pushItem);
    }
    return serviceSupportOptions;
  },

  hamyarContractTypeOptions: (state) =>
    (state.hamyarContractTypes || []).map((item) => ({
      value: item.id,
      text: item.title,
    })),

  hamyarContractStatusOptions: (state) =>
    (state.hamyarContractStatuses || []).map((item) => ({
      value: item.id,
      text: item.title,
    })),

  chanceOptions: (state) =>
    (state.chances || []).map((item) => ({
      value: item.id,
      text: item.title,
    })),

  callOptions: (state) => {
    const callOptions = [];
    state.calls.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      callOptions.push(pushItem);
    }
    return callOptions;
  },

  messageOptions: (state) => {
    const messageOptions = [];
    state.messages.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.subject,
      };
      messageOptions.push(pushItem);
    }
    return messageOptions;
  },

  contractOptions: (state) => {
    const contractOptions = [];
    state.contracts.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      contractOptions.push(pushItem);
    }
    return contractOptions;
  },

  meetingOptions: (state) => {
    const meetingOptions = [];
    state.meetings.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      meetingOptions.push(pushItem);
    }
    return meetingOptions;
  },

  taskOptions: (state) => {
    const taskOptions = [];
    state.tasks.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      taskOptions.push(pushItem);
    }
    return taskOptions;
  },

  messageStatusOptions: (state) => {
    const messageStatusOptions = [];
    state.messageStatuses.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      messageStatusOptions.push(pushItem);
    }
    return messageStatusOptions;
  },

  messageTypeOptions: (state) => {
    const messageTypeOptions = [];
    state.messageTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      messageTypeOptions.push(pushItem);
    }
    return messageTypeOptions;
  },

  messageActionOptions: (state) => {
    const messageActionOptions = [];
    state.messageActions.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      messageActionOptions.push(pushItem);
    }
    return messageActionOptions;
  },

  callTypeOptions: (state) => {
    const callTypeOptions = [];
    state.callTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      callTypeOptions.push(pushItem);
    }
    return callTypeOptions;
  },

  callStatusOptions: (state) => {
    const callStatusOptions = [];
    state.callStatuses.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      callStatusOptions.push(pushItem);
    }
    return callStatusOptions;
  },

  callNatureOptions: (state) => {
    const callNatureOptions = [];
    state.callNatures.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      callNatureOptions.push(pushItem);
    }
    return callNatureOptions;
  },

  callCategoryOptions: (state) => {
    const callCategoryOptions = [];
    state.callCategories.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      callCategoryOptions.push(pushItem);
    }
    return callCategoryOptions;
  },

  callSubjectOptions: (state) => {
    const callSubjectOptions = [];
    state.callSubjects.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      callSubjectOptions.push(pushItem);
    }
    return callSubjectOptions;
  },

  leadAddressTypeOptions: (state) => {
    const leadAddressTypeOptions = [];
    state.leadAddressTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      leadAddressTypeOptions.push(pushItem);
    }
    return leadAddressTypeOptions;
  },

  meetingStatusOptions: (state) => {
    const meetingStatusOptions = [];
    state.meetingStatuses.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      meetingStatusOptions.push(pushItem);
    }
    return meetingStatusOptions;
  },

  taxRateTypeOptions: (state) => {
    const taxRateTypeOptions = [];
    state.taxRateTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      taxRateTypeOptions.push(pushItem);
    }
    return taxRateTypeOptions;
  },

  addOrMinusTypeOptions: (state) => {
    const addOrMinusTypeOptions = [];
    state.addOrMinusTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      addOrMinusTypeOptions.push(pushItem);
    }
    return addOrMinusTypeOptions;
  },

  checkListTypeOptions: (state) => {
    const checkListTypeOptions = [];
    state.checkListTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      checkListTypeOptions.push(pushItem);
    }
    return checkListTypeOptions;
  },

  voucherSearchTypeOptions: (state) => {
    const voucherSearchTypeOptions = [];
    state.voucherSearchTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      voucherSearchTypeOptions.push(pushItem);
    }
    return voucherSearchTypeOptions;
  },

  paymentOptions: (state) => {
    const paymentOptions = [];
    state.paymentOptions.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      paymentOptions.push(pushItem);
    }
    return paymentOptions;
  },

  receiveOptions: (state) => {
    const receiveOptions = [];
    state.receiveOptions.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      receiveOptions.push(pushItem);
    }
    return receiveOptions;
  },

  studyFieldTypeOptions: (state) => {
    const studyFieldTypeOptions = [];
    state.studyFieldTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      studyFieldTypeOptions.push(pushItem);
    }
    return studyFieldTypeOptions;
  },

  degreeTypeOptions: (state) => {
    const degreeTypeOptions = [];
    state.degreeTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      degreeTypeOptions.push(pushItem);
    }
    return degreeTypeOptions;
  },

  employmentTypeOptions: (state) => {
    const employmentTypeOptions = [];
    state.employmentTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      employmentTypeOptions.push(pushItem);
    }
    return employmentTypeOptions;
  },

  insuranceTypeOptions: (state) => {
    const insuranceTypeOptions = [];
    state.insuranceTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      insuranceTypeOptions.push(pushItem);
    }
    return insuranceTypeOptions;
  },

  serviceStatusOptions: (state) => {
    const serviceStatusOptions = [];
    state.serviceStatuses.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      serviceStatusOptions.push(pushItem);
    }
    return serviceStatusOptions;
  },

  nationalityTypeOptions: (state) => {
    const nationalityTypeOptions = [];
    state.nationalityTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      nationalityTypeOptions.push(pushItem);
    }
    return nationalityTypeOptions;
  },

  occupationCategoryOptions: (state) => {
    const occupationCategoryOptions = [];
    state.occupationCategories.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      occupationCategoryOptions.push(pushItem);
    }
    return occupationCategoryOptions;
  },

  taxVehicleOptions: (state) => {
    const taxVehicleOptions = [];
    state.taxVehicles.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      taxVehicleOptions.push(pushItem);
    }
    return taxVehicleOptions;
  },

  taxHousingOptions: (state) => {
    const taxHousingOptions = [];
    state.taxHousings.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      taxHousingOptions.push(pushItem);
    }
    return taxHousingOptions;
  },

  decreaseSaleAddMinusOptions: (state) => {
    const decreaseSaleAddMinusOptions = [];
    state.decreaseSaleAddMinuses.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
        amount: item.amount,
        isPercentage: item.isPercentage,
      };
      decreaseSaleAddMinusOptions.push(pushItem);
    }
    return decreaseSaleAddMinusOptions;
  },

  giftTypeOptions: (state) => {
    const giftTypeOptions = [];
    state.giftTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      giftTypeOptions.push(pushItem);
    }
    return giftTypeOptions;
  },

  calculateTypeOptions: (state) => {
    const calculateTypeOptions = [];
    state.calculateTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      calculateTypeOptions.push(pushItem);
    }
    return calculateTypeOptions;
  },

  departmentOptions: (state) => {
    const departmentOptions = [];
    state.departments.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      departmentOptions.push(pushItem);
    }
    return departmentOptions;
  },

  contractTypeOptions: (state) => {
    const contractTypeOptions = [];
    state.contractTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      contractTypeOptions.push(pushItem);
    }
    return contractTypeOptions;
  },

  // سرویس مرخصی نام رشته‌ای عضو enum را می‌پذیرد (مثل Entitlement)
  leaveTypeOptions: (state) => {
    const leaveTypeOptions = [];
    state.leaveTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.key ?? item.id,
        text: item.title,
      };
      leaveTypeOptions.push(pushItem);
    }
    return leaveTypeOptions;
  },

  jobGroupOptions: (state) => {
    const jobGroupOptions = [];
    state.jobGroups.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      jobGroupOptions.push(pushItem);
    }
    return jobGroupOptions;
  },

  insuranceWorkplaceOptions: (state) => {
    const insuranceWorkplaceOptions = [];
    state.insuranceWorkplaces.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      insuranceWorkplaceOptions.push(pushItem);
    }
    return insuranceWorkplaceOptions;
  },

  agreementRowOptions: (state) => {
    const agreementRowOptions = [];
    state.agreementRows.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      agreementRowOptions.push(pushItem);
    }
    return agreementRowOptions;
  },

  calculateDeductionRateTypeOptions: (state) => {
    const calculateDeductionRateTypeOptions = [];
    state.calculateDeductionRateTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      calculateDeductionRateTypeOptions.push(pushItem);
    }
    return calculateDeductionRateTypeOptions;
  },

  formulaOptions: (state) => {
    const formulaOptions = [];
    state.formulas.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
        // کلید فرمول برای درج در عبارت ماشین‌حساب لازم است
        key: item.key,
        code: item.code,
      };
      formulaOptions.push(pushItem);
    }
    return formulaOptions;
  },

  exemptionTypeOptions: (state) => {
    const exemptionTypeOptions = [];
    state.exemptionTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      exemptionTypeOptions.push(pushItem);
    }
    return exemptionTypeOptions;
  },

  calculateTaxForHourlyOptions: (state) => {
    const calculateTaxForHourlyOptions = [];
    state.calculateTaxForHourlys.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      calculateTaxForHourlyOptions.push(pushItem);
    }
    return calculateTaxForHourlyOptions;
  },

  calculateTaxTypeOptions: (state) => {
    const calculateTaxTypeOptions = [];
    state.calculateTaxTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      calculateTaxTypeOptions.push(pushItem);
    }
    return calculateTaxTypeOptions;
  },

  legalTaxExceptionOptions: (state) => {
    const legalTaxExceptionOptions = [];
    state.legalTaxExceptions.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      legalTaxExceptionOptions.push(pushItem);
    }
    return legalTaxExceptionOptions;
  },

  functionTypeOptions: (state) => {
    const functionTypeOptions = [];
    state.functionTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      functionTypeOptions.push(pushItem);
    }
    return functionTypeOptions;
  },

  calculateOffOverTimeTypeOptions: (state) => {
    const calculateOffOverTimeTypeOptions = [];
    state.calculateOffOverTimeTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      calculateOffOverTimeTypeOptions.push(pushItem);
    }
    return calculateOffOverTimeTypeOptions;
  },

  benefitsAndDeductionOptions: (state) => {
    const benefitsAndDeductionOptions = [];
    state.benefitsAndDeductions.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
        isAddition: item.isAddition,
      };
      benefitsAndDeductionOptions.push(pushItem);
    }
    return benefitsAndDeductionOptions;
  },

  personnels: (state) => {
    return state.personnels;
  },

  personnelOptions: (state) => {
    const personnelOptions = [];
    state.personnels.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.personId,
        code: item.code,
        text: item.title || item.fullName,
        personId: item.personId,
        nationalId: item.nationalId,
        fullName: item.fullName,
        personnelCardNumber: item.personnelCardNumber,
        fatherName: item.fatherName,
      };
      personnelOptions.push(pushItem);
    }
    return personnelOptions;
  },

  additionalContractParameterOptions: (state) => {
    const additionalContractParameterOptions = [];
    state.additionalContractParameters.forEach(func);
    function func(item, index) {
      const pushItem = {
        index: index,
        value: item.id,
        code: item.code,
        text: item.title,
        fieldTypeId: item.fieldTypeId,
        dropDown: item.dropDown,
        uniqueKey: "param" + index,
      };
      additionalContractParameterOptions.push(pushItem);
    }
    return additionalContractParameterOptions;
  },

  shamsiMonthOptions: (state) => {
    const shamsiMonthOptions = [];
    state.shamsiMonths.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      shamsiMonthOptions.push(pushItem);
    }
    return shamsiMonthOptions;
  },

  suiteOptions: (state) => {
    const suiteOptions = [];
    state.suites.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      suiteOptions.push(pushItem);
    }
    return suiteOptions;
  },

  participationOptions: (state) => {
    const participationOptions = [];
    state.participation.forEach(func);
    function func(item) {
      if (!item.floatAccountTitle) {
        item.floatAccountTitle = "";
      }
      const pushItem = {
        value: item.id,
        text:
          "کد" + " " + item.code + " - " + item.floatAccountTitle,
        fullName: item.personFullName,
        personId: item.personId,
      };
      participationOptions.push(pushItem);
    }
    return participationOptions;
  },

  crimesRewardSubjectOptions: (state) => {
    const crimesRewardSubjectOptions = [];
    state.crimesRewardSubject.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      crimesRewardSubjectOptions.push(pushItem);
    }
    return crimesRewardSubjectOptions;
  },

  paymentNotificationTypeOptions: (state) => {
    const paymentNotificationTypeOptions = [];
    state.paymentNotificationType.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      paymentNotificationTypeOptions.push(pushItem);
    }
    return paymentNotificationTypeOptions;
  },

  estimationSubjectOptions: (state) => {
    const estimationSubjectOptions = [];
    state.estimationSubject.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      estimationSubjectOptions.push(pushItem);
    }
    return estimationSubjectOptions;
  },

  crimesRewardTypeOptions: (state) => {
    const crimesRewardTypeOptions = [];
    state.crimesRewardType.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      crimesRewardTypeOptions.push(pushItem);
    }
    return crimesRewardTypeOptions;
  },

  unitCountOptions: (state) => {
    const unitCountOptions = [];
    state.unitCount.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
        coefficient: item.coefficient,
      };
      unitCountOptions.push(pushItem);
    }
    return unitCountOptions;
  },

  advanceCartableConfirmOptions: (state) => {
    const advanceCartableConfirmOptions = [];
    state.advanceCartableConfirm.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.priority,
        text: item.title,
      };
      advanceCartableConfirmOptions.push(pushItem);
    }
    return advanceCartableConfirmOptions;
  },

  leaveCartableConfirmOptions: (state) => {
    const leaveCartableConfirmOptions = [];
    state.leaveCartableConfirm.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.priority,
        text: item.title,
      };
      leaveCartableConfirmOptions.push(pushItem);
    }
    return leaveCartableConfirmOptions;
  },
  missionCartableConfirmOptions: (state) => {
    const missionCartableConfirmOptions = [];
    state.missionCartableConfirm.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.priority,
        text: item.title,
      };
      missionCartableConfirmOptions.push(pushItem);
    }
    return missionCartableConfirmOptions;
  },

  hamsazSmsTemplates: (state) => {
    return state.hamsazSmsTemplates;
  },
  hamsazSmsTemplatesOptions: (state) => {
    const hamsazSmsTemplatesOptions = [];
    state.hamsazSmsTemplates.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      hamsazSmsTemplatesOptions.push(pushItem);
    }
    return hamsazSmsTemplatesOptions;
  },

  hamsazSmsSettings: (state) => {
    return state.hamsazSmsSettings;
  },
  hamsazSmsSettingOptions: (state) => {
    const hamsazSmsSettingOptions = [];
    state.hamsazSmsSettings.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      hamsazSmsSettingOptions.push(pushItem);
    }
    return hamsazSmsSettingOptions;
  },

  financialSystemTypeOptions: (state) => {
    const financialSystemTypeOptions = [];
    state.financialSystemTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      financialSystemTypeOptions.push(pushItem);
    }
    return financialSystemTypeOptions;
  },

  excelSampleOptions: (state) => {
    const excelSampleOptions = [];
    state.excelSamples.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      excelSampleOptions.push(pushItem);
    }
    return excelSampleOptions;
  },

  employeeClubPermissions: (state) => {
    return state.employeeClubPermissions;
  },

  saltDateTypeOptions: (state) => {
    const saltDateTypeOptions = [];
    state.saltDateTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      saltDateTypeOptions.push(pushItem);
    }
    return saltDateTypeOptions;
  },

  orderCartableConfirmOptions: (state) => {
    const orderCartableConfirmOptions = [];
    state.orderCartableConfirm.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.priority,
        text: item.title,
      };
      orderCartableConfirmOptions.push(pushItem);
    }
    return orderCartableConfirmOptions;
  },

  taskDateTypeOptions: (state) => {
    const taskDateTypeOptions = [];
    state.taskDateTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      taskDateTypeOptions.push(pushItem);
    }
    return taskDateTypeOptions;
  },

  taskDeleteScopeOptions: (state) => {
    const taskDeleteScopeOptions = [];
    state.taskDeleteScopes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      taskDeleteScopeOptions.push(pushItem);
    }
    return taskDeleteScopeOptions;
  },

  preFactorOptions: (state) => {
    const preFactorOptions = [];
    state.preFactors.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.code,
      };
      preFactorOptions.push(pushItem);
    }
    return preFactorOptions;
  },

  // Static Getters ---------------------------------------------------------------
  // نوع پیوست کالای سفارش (میتای شیرآلات)
  orderCommodityAttachmentKindOptions() {
    return [
      { value: 1, text: label.caption.attachmentKindMap },
      { value: 2, text: label.caption.attachmentKindDataSheet },
      { value: 3, text: label.caption.attachmentKindQc },
    ];
  },

  staticOptions() {
    return [
      { value: 1, text: label.caption.caseOne },
      { value: 2, text: label.caption.caseTwo },
      { value: 3, text: label.caption.caseThree },
    ];
  },

  booleanOptions() {
    return [
      { value: "true", text: label.caption.yesHas },
      { value: "false", text: label.caption.noHaveNot },
    ];
  },

  receiveFilterOptions() {
    return [
      { value: 1, text: label.caption.receiveDate },
      { value: 2, text: label.caption.issueDate },
      { value: 3, text: label.caption.turnDate },
    ];
  },

  paymentFilterOptions() {
    return [
      { value: 1, text: label.caption.paymentDate },
      { value: 2, text: label.caption.issueDate },
      { value: 3, text: label.caption.turnDate },
    ];
  },

  saleGroupPolicyOptions() {
    return [
      { value: 1, text: label.caption.addPercentageSellingPrice },
      { value: 2, text: label.caption.addPriceTypeSellingPrice },
      { value: 3, text: label.caption.addPercentageCurrentPrice },
      { value: 4, text: label.caption.addPiceCurrentPrice },
    ];
  },

  factorOperationsOptions() {
    return [
      { value: 1, text: label.caption.cancel },
      { value: 2, text: label.caption.confirm },
      { value: 3, text: label.caption.cancelCancellation },
      { value: 4, text: label.caption.cancelApproved },
    ];
  },

  cancelOptions() {
    return [
      { value: 3, text: label.caption.allFactors },
      { value: 1, text: label.caption.cancelledInvoices },
      { value: 2, text: label.caption.uncanceledInvoices },
    ];
  },
  documentVerificationOptions() {
    return [
      { value: 1, text: label.caption.confirm },
      { value: 2, text: label.caption.disconfirm },
    ];
  },

  outputTypeOptions() {
    return [
      { value: 1, text: label.form.monthly },
      { value: 2, text: label.form.daily },
      { value: 3, text: label.form.inVoucher },
    ];
  },

  typeOptions() {
    return [
      { value: 1, text: label.caption.inReview },
      { value: 2, text: label.caption.approved },
      { value: 3, text: label.caption.rejected },
    ];
  },

  addInfoTypeOptions() {
    return [
      { value: 1, text: label.caption.withoutBaseInformation },
      { value: 2, text: label.caption.withBaseInformation },
    ];
  },

  accountControlActions() {
    return [
      { value: 1, text: label.caption.control },
      { value: 2, text: label.caption.notControl },
    ];
  },

  isAdditionTypes() {
    return [
      { value: true, text: label.form.benefits },
      { value: false, text: label.form.deduction },
    ];
  },

  paperTypes() {
    return [
      { value: 1, text: label.form.paperNumber },
      { value: 2, text: label.form.chequeNumber },
    ];
  },

  monthOptions() {
    return [
      { value: 1, text: label.table.farvardin },
      { value: 2, text: label.table.ordibehesht },
      { value: 3, text: label.table.khordad },
      { value: 4, text: label.table.tir },
      { value: 5, text: label.table.mordad },
      { value: 6, text: label.table.shahrivar },
      { value: 7, text: label.table.mehr },
      { value: 8, text: label.table.aban },
      { value: 9, text: label.table.azar },
      { value: 10, text: label.table.dey },
      { value: 11, text: label.table.bahman },
      { value: 12, text: label.table.esfand },
    ];
  },

  saleTeamOptions: (state) => {
    return state.saleTeams.map((item) => ({
      value: item.id,
      text: item.title,
    }));
  },

  saleRegionOptions: (state) => {
    return state.saleRegions.map((item) => ({
      value: item.id,
      text: item.title,
    }));
  },

  taxBillTypesOptions: (state) => {
    const taxBillTypesOptions = [];
    state.taxBillTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      taxBillTypesOptions.push(pushItem);
    }
    return taxBillTypesOptions;
  },

  taxBillSubjectsOptions: (state) => {
    const taxBillSubjectsOptions = [];
    state.taxBillSubjects.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      taxBillSubjectsOptions.push(pushItem);
    }
    return taxBillSubjectsOptions;
  },

  taxBuyerTypesOptions: (state) => {
    const taxBuyerTypesOptions = [];
    state.taxBuyerTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      taxBuyerTypesOptions.push(pushItem);
    }
    return taxBuyerTypesOptions;
  },

  taxClearingMethodsOptions: (state) => {
    const taxClearingMethodsOptions = [];
    state.taxClearingMethods.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      taxClearingMethodsOptions.push(pushItem);
    }
    return taxClearingMethodsOptions;
  },

  taxInvoiceStatusesOptions: (state) => {
    const taxInvoiceStatusesOptions = [];
    state.taxInvoiceStatuses.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      taxInvoiceStatusesOptions.push(pushItem);
    }
    return taxInvoiceStatusesOptions;
  },

  taxCurrencyTypesOptions: (state) => {
    const taxCurrencyTypesOptions = [];
    state.taxCurrencyTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      taxCurrencyTypesOptions.push(pushItem);
    }
    return taxCurrencyTypesOptions;
  },

  taxOrganizationTypesOptions: (state) => {
    const taxOrganizationTypesOptions = [];
    state.taxOrganizationTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      taxOrganizationTypesOptions.push(pushItem);
    }
    return taxOrganizationTypesOptions;
  },

  taxMltTypesOptions: (state) => {
    const taxMltTypesOptions = [];
    state.taxMltTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      taxMltTypesOptions.push(pushItem);
    }
    return taxMltTypesOptions;
  },

  taxBillPatternsOptions: (state) => {
    const taxBillPatternsOptions = {};
    Object.keys(state.taxBillPatterns).forEach(func);
    function func(billTypeId) {
      const options = [];
      state.taxBillPatterns[billTypeId].forEach(pushFunc);
      function pushFunc(item) {
        const pushItem = {
          value: item.id,
          text: item.title,
        };
        options.push(pushItem);
      }
      taxBillPatternsOptions[billTypeId] = options;
    }
    return taxBillPatternsOptions;
  },
};
